import React from 'react';
import {
  ArrowDownOutlined,
  MinusOutlined,
  ArrowUpOutlined,
  FireOutlined,
} from '@ant-design/icons';

const priorityConfig = {
  low: { icon: <ArrowDownOutlined style={{ color: '#36B37E' }} /> },
  medium: { icon: <MinusOutlined style={{ color: '#FFAB00' }} /> },
  high: { icon: <ArrowUpOutlined style={{ color: '#FF5630' }} /> },
  highest: { icon: <FireOutlined style={{ color: '#DE350B' }} /> },
};

export default priorityConfig;
